/* === AmourPrint CRO - sticky add-to-cart bar + size-select fix (2026-06-30 v4, credit text removed) === */
(function(){
  if(!/\/products\//.test(location.pathname))return;
  /* only the CHECKED size is green; hide our old floating "Most popular" line (native "(Most Popular)" label already shows) */
  if(!document.getElementById('ap-fix-css')){
    var st=document.createElement('style');st.id='ap-fix-css';
    st.textContent='.product variant-selects .product-form__input--pill input:not(:checked) + label.ap-pop{background-color:transparent !important;border-color:#E2DDD0 !important;color:inherit !important;}'+
      '.ap-hint{display:none !important;}';
    (document.head||document.documentElement).appendChild(st);
  }
  function realBtn(){ return document.querySelector('.product-form__buttons .product-form__submit, .product .product-form__submit'); }
  function build(){
    if(document.getElementById('ap-sticky'))return;
    if(document.querySelector('#md-sticky-atc .product-form__submit, #md-sticky-atc button'))return;
    var btn=realBtn(); if(!btn)return;
    var bar=document.createElement('div'); bar.id='ap-sticky';
    bar.style.cssText='position:fixed;left:0;right:0;bottom:0;z-index:60;background:#fff;border-top:1px solid #E2DDD0;box-shadow:0 -2px 12px rgba(0,0,0,.07);padding:8px 12px;display:none;align-items:center;gap:10px;';
    bar.innerHTML='<div style="flex:1;font-size:12px;color:#2C2C2A;font-weight:600;line-height:1.25;">Your custom canvas<br><span style="color:#6B6B67;font-weight:400;font-size:11px;">Personalized just for you</span></div>';
    var b=document.createElement('button'); b.type='button'; b.textContent='Add to cart';
    b.style.cssText='background:#0F8A6C;color:#fff;border:none;border-radius:8px;padding:12px 18px;font-size:14px;font-weight:600;white-space:nowrap;';
    b.addEventListener('click',function(){ var rb=realBtn(); if(rb){ rb.click(); rb.scrollIntoView({behavior:'smooth',block:'center'}); } });
    bar.appendChild(b);
    document.body.appendChild(bar);
    function onScroll(){
      var rb=realBtn(); if(!rb){bar.style.display='none';return;}
      var nearBottom=(window.innerHeight+window.scrollY)>=(document.body.scrollHeight-240);
      var r=rb.getBoundingClientRect();
      var atcVisible=(r.top<window.innerHeight && r.bottom>0);
      bar.style.display=(!atcVisible && !nearBottom)?'flex':'none';
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    onScroll();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
  document.addEventListener('shopify:section:load',function(){setTimeout(build,200);});
  setTimeout(build,1200);setTimeout(build,2600);
})();
